import React, { ReactNode, useState } from "react";

import * as S from "./style";

export type TabItem = {
  id: string;
  title: string;
  content?: ReactNode;
  disabled?: boolean;
};

type TabsProps = {
  tabs: TabItem[];
  maxWidth?: boolean;
  onClick?: (tabId: string) => void;
  className?: string;
};

export function Tabs({ tabs = [], maxWidth, onClick, className }: TabsProps) {
  const [activeTab, setActiveTab] = useState(0);

  const activeTabContent = tabs.find(
    (_, tabIndex) => tabIndex === activeTab
  )?.content;

  const tabsQuantity = tabs.length;

  const handleClickTab = (tabIndex: number, tabId: string) => {
    setActiveTab(tabIndex);
    onClick?.(tabId);
  };

  return (
    <S.TabsCardWrapper
      style={{
        maxWidth: !maxWidth ? 400 : "",
      }}
      className={className}
    >
      <S.TabsTitlesContainer>
        {tabs.map((tab, tabIndex) => (
          <S.TabTitle
            key={`tab-title-${tab.title}`}
            className={activeTab === tabIndex ? "active" : ""}
            onClick={() => handleClickTab(tabIndex, tab.id)}
            disabled={tab.disabled}
            style={{
              cursor: tab.disabled ? "not-allowed" : "pointer",
              opacity: tab.disabled ? 0.5 : undefined,
            }}
            type="button"
            data-testid={`tab_${tab.id}`}
          >
            {tab.title}
          </S.TabTitle>
        ))}
        <S.ActiveTab activeIndex={activeTab} tabsQuantity={tabsQuantity} />
      </S.TabsTitlesContainer>
      {activeTabContent || null}
    </S.TabsCardWrapper>
  );
}
